import React, { Component } from 'react';
import { DropTarget } from 'react-dnd';

import CalendarItemsTypes from './CalendarItemTypes';
import * as CalendarState from '../../../state/reducer/calendar/calendar';
import Console from '../../../lib/debug';

const squareTarget = {
    drop(props, monitor) {
        let item = monitor.getItem();
        CalendarState.dropCalendarSession(
            item.dayKey,
            props.dayKey,
            item.sessionKey
        );
    }
};

function collect(connect, monitor) {
    return {
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver()
    };
}

class CalendarDropTarget extends Component {
    render() {
        Console.render('CalendarDropTarget');
        const { connectDropTarget, isOver } = this.props;
        return connectDropTarget(
            <div className="cal-drop-target">
                {isOver && (
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            zIndex: 1,
                            opacity: 0.5,
                            backgroundColor: '#D5EEFA'
                        }}
                    />
                )}
            </div>
        );
    }
}

export default DropTarget(CalendarItemsTypes.CARD, squareTarget, collect)(
    CalendarDropTarget
);
